export default "__VITE_ASSET__yOIdtzmc__"